import { Component,Inject, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TranscriptionCreateService } from '../transcription-create.service';
import * as global from '../../global';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as moment from 'moment';
import { NoteEditorService } from '../../note-editor/note-editor.service';
import { Note } from '../../note-editor/model/note';
import { TranscriptionService } from 'src/app/services/transcription.service';
import { AuthService } from 'src/app/services/auth.service';
import { HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { PCCService } from 'src/app/services/pcc.service';
import * as copy from 'copy-to-clipboard';
import { ToastrService } from 'ngx-toastr';
// UPLOAD FILE DIALOG
export interface ViewNoteDialog {
  note
  timezone:any,
  void_census: any
}

@Component({
  selector: 'app-view-note-sidebar',
  templateUrl: './view-note-sidebar.component.html',
  styleUrls: ['./view-note-sidebar.component.css']
})
export class ViewNoteSidebar implements OnInit {
  global = global;
  
  note;
  note_id:string;
  height:number;
  loaderId = 'view-note-loader';
  addendums:any[];
  timezone;
  currentUser: any;
  voidCensus: Boolean  = true;
  dontShowPreview: Boolean;
  readOnly: any;
  isNurseUser: boolean = false;
  company_id: any;
  routerLink: any;
  @Input() noteObj: any;
  @Output() closeNote = new EventEmitter<boolean> ();
  data: any
  pccNote;
  facility;
  patient;
  isLoading: boolean = false;
  constructor(
    // private loader: NgxUiLoaderService,
    private noteEditorService:NoteEditorService,
    private transcriptionService:TranscriptionService,
    private transcriptionCreateService:TranscriptionCreateService,
    private _auth: AuthService,
    private _router: Router,
    private pccService: PCCService,
    private toastr: ToastrService
    ) { 
      this.currentUser = this._auth.currentUser;
        console.log('this.currentUser',this.currentUser)
        if (this.currentUser.user_type.toLowerCase() === 'nurse') {
          this.isNurseUser = true;
        }

    }
    
    async ngOnInit() {
      this.data = this.noteObj;
      if(this.data.isDnNote) {
        if(this.data) {
          this.note = this.data.note;
          this.note_id = this.data.note_id || this.note._id;
          this.timezone = this.note.timezone;
          this.readOnly = this.note.readOnly;
          if(!(this.data.void_census)){
            this.voidCensus = false;
          }
        }     
        if (this.note_id) {
          const noteResponse: any = await this.transcriptionService.get_transcription_by_id(this.note_id).toPromise();
          if (noteResponse.status === 200) {
            this.note = noteResponse.data;
          }
        }
        this.initAddendums();
        if (this._router.url.includes("/company"))
          this.routerLink = `company/${this.currentUser.company_id}/note-editor/${this.note._id}`;
        else
          this.routerLink = `/note-editor/${this.note._id}`;
      }
      else {
        this.pccNote = this.data.pccNote;
        this.patient = this.data.patient;
        this.facility = this.data.patient.facility_id_ref;
        this.initPccNote();
      }
    }

    initAddendums() {
      this.transcriptionCreateService.getNoteAddendums({noteId: this.note._id}).subscribe((response:any) => {
        if (response.status === 200) {
          this.addendums = response.data.array;
          this.height=80;
        }
      });
    }

    onCloseNote() {
      this.closeNote.emit(false);
    }


    applyTimezone(date) {
      if(this.data.isDnNote) {
        
        let serviceDate = new Date(new Date(date).toLocaleString('en-US', { timeZone: this.timezone }))

        return serviceDate;
      }
      else {
        return moment(new Date(date).toLocaleString('en-US', { timeZone:  this.pccNote.filterServiceDate.timezone })).format('MMM DD, YYYY h:mm a');
      }
      // return moment(new Date(date)).format('MMM DD, YYYY h:mm a');
     
      // return moment(new Date(date).toLocaleString('en-US', { timeZone:  this.note.filterServiceDate.timezone })).format('MMM DD, YYYY h:mm a');
    }

    generatePDFNote() {
      this.noteEditorService.generatePDFNote(this.note._id,this.currentUser.company_id).subscribe((res: any) => {
          if (res instanceof HttpResponse) {
              var url = window.URL.createObjectURL(res.body);
              var a = document.createElement('a');
              document.body.appendChild(a);
              a.setAttribute('style', 'display: none');
              a.href = url;
              a.download = `${this.note.transcribtion_title}.pdf`;
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove(); // remove the element
          }
      });
  }
  getDOS() {
    let {year, month, day, hour, minute} = this.note.date_obj;
    if(month < 10){
        month = '0' + month;
    }
    if(day < 10){
        day = '0' + day;
    }
    let str = `${month}/${day}/${year}`;
    if(hour && minute) {
        str += ` ${hour}:${minute}`
    }
    return str;
  }

  getAddendumDate(addendum) {
    if (addendum.created_date_obj) {
      let {year, month, day, hour, minute} = addendum.created_date_obj;
      if (month < 10) {
          month = '0' + month;
      }
      if (day < 10) {
          day = '0' + day;
      }
      let str = `${month}/${day}/${year}`;
      if (hour && minute) {
          str += ` ${hour}:${minute}`
      }
      return str;
    } else {
      return moment(this.applyTimezone(addendum.createdAt)).format(global.moment_date_format2)
    }
  }

  async updateOtherSettings() {
    let updatePromise = Promise.resolve();

    if ( this.dontShowPreview ) {
      const settingKey = 'preview_note';

      const otherSettings = {
        [ settingKey ]: typeof this._auth.currentUser.other_settings[ settingKey ] === 'boolean' ? !this._auth.currentUser.other_settings[ settingKey ] : false
      }
  
      updatePromise = this._auth.setOtherUserSettings( otherSettings ).toPromise();
    }

    await updatePromise;
  }

  async initPccNote() {
    try {
      this.isLoading = true;
      const pcc_orgUuid = this.facility.pcc_orgUuid;
      const response: any = await lastValueFrom(this.pccService.getNote(pcc_orgUuid, this.pccNote.progressNoteId, this.patient.pcc_patientId));
      this.pccNote = response.data;
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  copyToClipboard(text) {
    text = text.split('<br />').join('\n');
    copy(text);
    this.toastr.info('Copied to clipboard')
  }
  getSection(section) {
    if(Array.isArray(this.pccNote.sections)) {
      return this.pccNote.sections.find(s => s.name === section)
    }

    // if Details section does not exist, return Note Text
    if(section === 'Details') {
      return this.pccNote.sections.find(s => s.name === 'Note Text')
    }
// 0: {name: "Date of Service", value: "12/21/2020 07:46 AM"}
// 1: {name: "Visit Type", value: "FORMATTED INITIAL EVAL"}
// 2: {name: "Transition of Care", value: "N/A"}
// 3: {name: "History Details", value: "N/A"}
// 4: {name: "Details",…}
// 5: {name: "Provider", value: "Provider Provider 4, M.D."}
// 6: {name: "Signed Date", value: "12/21/2020 07:49 AM"}
  }
  isNoteTextSection(sectionName) {
    return ['Note Text', 'Details'].includes(sectionName);
  }
}
